import { createContext, useContext } from "react";
import { InitialValues } from "./initial-values-types";

export const InitialValuesContext = createContext<InitialValues | null>(null);

export function useInitialValues() {
  return useContext(InitialValuesContext);
}
